export default (state = {}, action) => {
  if (action.type === "MANUAL_FORWARD") {
    state.manualForward = action.data.manualForward;
    state.manualForwardLabel =
      action.data.manualForwardLabel || "Jetzt fortfahren";
  }

  return state;
};
